module.exports = __webpack_public_path__ + "img/certif_02.b05e3c64.jpg";